/** API route map: URLS.Controller.ClientContactTask */
export const ClientContactTask = {
      Name: 'ClientContactTask/',
      GetAllTask: 'client-contact-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
};
